import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Typography from '@material-ui/core/Typography';
import Select from "components/form/Select";
import { useMutation } from 'react-apollo';
import Button from 'components/common/Button';
import { UPDATE_CALENDAR_ACCOUNT } from 'graphql/calendar';
import useSnack from "hooks/useSnack";

const DURATIONS = [
  { label: '5 Minutes', value: 5 },
  { label: '10 Minutes', value: 10 },
  { label: '15 Minutes', value: 15 },
  { label: '20 Minutes', value: 20 },
  { label: '25 Minutes', value: 25 },
  { label: '30 Minutes', value: 30 },
];

const Settings = ({ account }) => {
  const [update] = useMutation(UPDATE_CALENDAR_ACCOUNT);
  const [buffer, setBuffer] = useState({
    before: account.buffer_before,
    after: account.buffer_after
  });
  const snack = useSnack();

  const onSave = async () => {
    await update({
      variables: {
        id: account.id,
        data: {
          buffer_before: buffer.before,
          buffer_after: buffer.after
        }
      }
    });
    snack.success('Settings updated');
  };

  const onSelectChange = (name) => (value) => {
    setBuffer({
      ...buffer,
      [name]: value
    });
  };

  return (
    <Box marginBottom={3}>
      <Card>
        <CardContent>
          <Typography variant="h6" style={{ marginBottom: 16 }}>Settings</Typography>
          <Grid container spacing={3}>
            <Grid item sm={4}>
              <Select
                transformValue
                isClearable
                isMulti={false}
                value={buffer.before}
                onChange={onSelectChange('before')}
                options={DURATIONS}
                label="Buffer before start of meeting"
                helpText="Minimum number of minutes that must be free before an available period starts."
              />
            </Grid>
            <Grid item sm={4}>
              <Select
                transformValue
                isClearable
                isMulti={false}
                value={buffer.after}
                onChange={onSelectChange('after')}
                options={DURATIONS}
                label="Buffer after end of meeting"
                helpText="Minimum number of minutes that must be free after the available period ends."
              />
            </Grid>
          </Grid>
          <Button variant="contained" color="primary" onClick={onSave}>Save</Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Settings;

